import { ReactNode } from "react";
import { FontStyles } from "../../utils/font-styles";
import "../../../assets/fa-icons/css/fontawesome.css";
import "../../../assets/fa-icons/css/sharp-regular.css";

interface ErrorMessageProps {
  children: ReactNode;
}

export const ErrorMessage = ({ children }: ErrorMessageProps) => (
  <div className="flex items-start gap-2 text-brick">
    <span className={FontStyles["body-md"]}>
      <i className={`fa-circle-exclamation fa-sharp fa-regular ${FontStyles["body-s"]}`} />
      &nbsp;&nbsp;{children}
    </span>
  </div>
);
